import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import '../../css/mobile/MAdmin.css';
import axios from '../../services/axiosInstance';
import commonCheck from "../../assets/img/commonCheck.png";
import commonClose from "../../assets/img/commonClose.png";
import maCateImg from "../../assets/img/m-a-cate.png";
import {MdKeyboardArrowDown} from "react-icons/md";
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import IntegDetailPopup from "../../components/web/modal/IntegDetailPopup";
import MAdminPageSmallEvent from "./MAdminPageSmallEvent";
import MAdminSearchEvent from "./MAdminSearchEvent";
import {useWebSocket} from "../../services/WebsocketContext";
import {BsCaretDown, BsCaretUp} from "react-icons/bs";
import MAdminYmdEvent from "./MAdminYmdEvent";

const safeNum = (val) => {
    if (val === null || val === undefined) return 0;
    const num = Number(val);
    return isNaN(num) ? 0 : num;
};

function MAdminPaymentsListPg() {

    /** region DataTable */

    const [data, setData] = useState([]);

    /** endregion*/

    /** region Function */

    const LCAT = localStorage.getItem('adminToken');
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState('');
    const [userNm, setUserNm] = useState('');

    const [adminInfo, setAdminInfo] = useState([]);
    const selectAdminInfo = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response)=> {
                setAdminInfo(response.data[0])
            })
            .catch(()=> {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        selectAdminInfo();
    }, [])

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!adminInfo.mbNum || isSubscribedRef.current) return;

            if (!stompClient && !isConnected) {
                await websocketConnect(adminInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [adminInfo.mbNum, isConnected, stompClient]);

    //region ScrollPagination

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const startHandle = (e) => {
        setStartDate(e.target.value);
    };
    const endHandle = (e) => {
        setEndDate(e.target.value);
    };
    const stringStartDate = startDate.replace(/-/g, '');
    const stringEndDate = endDate.replace(/-/g, '');

    const currentDate = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(currentDate.getDate() - 7); // 1주일

    const defaultMonth = () => {
        const stringStartDate = formatDateChat(oneWeekAgo);
        const stringEndDate = formatDateChat(currentDate);
        setStartDate(stringStartDate);
        setEndDate(stringEndDate);
    }

    useEffect(() => {
        defaultMonth();
    }, []);

    const formatDateChat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const [perPg, setperPg] = useState(10); // ★ perPg만 사용하여 고정된 보여주기식 수량만 핸들링
    const handleSelectChange = (e) => {
        let newPerPage = 10; // 기본값 설정

        if (e && e.target && e.target.value !== undefined) {
            // 1. PC 버전의 native select 이벤트인 경우
            newPerPage = parseInt(e.target.value, 10);
        } else if (typeof e === 'number' || typeof e === 'string') {
            // 2. 모바일 custom click 이벤트에서 값만 직접 넘겨준 경우 (e 자체가 10, 15 등일 때)
            newPerPage = parseInt(e, 10);
        } else {
            // 3. 클릭 이벤트 객체가 넘어왔으나 일반 태그일 경우 attribute나 text에서 추출 시도
            const attrVal = e?.target?.getAttribute('value') || e?.target?.innerText;
            if (attrVal) {
                newPerPage = parseInt(attrVal, 10);
            }
        }

        // 최종 파싱 결과가 숫자가 아니면 기본값 10으로 안전하게 보정
        setperPg(isNaN(newPerPage) ? 10 : newPerPage);
    };

    const [popupVisible, setPopupVisible] = useState(false);
    const togglePopup = () => {
        setPopupVisible(!popupVisible);
    };

    const [alertShow, setAlertShow] = useState(false);
    const [alertShow2, setAlertShow2] = useState(false);
    const msgConfirmData1 = "확인 하시겠습니까?";
    const msgConfirmData2 = "결제승인이 완료됩니다.";
    const msgConfirmData3 = "정말 취소하시겠습니까?";
    const msgConfirmData4 = "결제가 취소처리 됩니다.";
    const modalCancel = useCallback (() => {setAlertShow(false);})
    const modalCancel2 = useCallback(() => {setAlertShow2(false);})
    const alert = (()=> {setAlertShow(true)})
    const alert2 = (() => {setAlertShow2(true)})

    const [checked, setChecked] = useState([]);

    const checkBoxChange = (id) => {
        setChecked((prevSelectedData) => {
            if (prevSelectedData.includes(id)) {
                return prevSelectedData.filter((item) => item !== id);
            } else {
                return [...prevSelectedData, id];
            }
        });
    };

    const allcheckBoxChange = (e) => {
        const visibleIds = visibleData.map((item) => item.seqNum);
        if (e.target.checked) {
            setChecked((prev) => Array.from(new Set([...prev, ...visibleIds])));
        } else {
            setChecked((prev) => prev.filter((id) => !visibleIds.includes(id)));
        }
    };

    const [searchInput, setSearchInput] = useState('');
    const handleSearchInputChange = (event) => {
        setSearchInput(event.target.value);
    };

    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortOrder("asc");
        }
    };

    const selectedTotalPricePrint = (pay) => {
        if (!pay) return 0;

        let prodTotal = 0;
        let shipTotal = 0;
        let etcTotal = 0;
        let integTotal = 0;

        // 상품금액 총합 계산
        if (pay.payType === "PT0") {
            const ttEtcFee = pay.ttEtcFee || 0;
            const ttProdExpense = pay.ttProdExpense || 0;
            prodTotal += ttEtcFee + ttProdExpense;
            return prodTotal;

            // 해외배송비 총합 계산
        } else if (pay.payType === "PT1") {
            const prices = [
                pay.ttFedexPrice, pay.ttFedexEcoPrice, pay.ttDhlPrice, pay.ttEmsPrice,
                pay.ttEmsPrePrice, pay.ttUpsPrice, pay.ttUpsEcoPrice, pay.ttKPackPrice,
                pay.ttAirSPrice, pay.ttSeaPrice, pay.ttDomPrice
            ];
            const validPrice = prices.find(price => price > 0) || 0;
            shipTotal += validPrice;
            return shipTotal;

            // 기타비용 총합 계산
        } else if (pay.payType === "PT2") {
            const courierPay = pay.courierPay || 0;
            const returnFee = pay.returnFee || 0;
            const deliveryFee = pay.deliveryFee || 0;
            const repackFee = pay.repackFee || 0;
            const agencyFee = pay.agencyFee || 0;
            const removeFee = pay.removeFee || 0;
            const comprFee = pay.comprFee || 0;
            const etcPrice = pay.etcPrice || 0;
            const etcFee = pay.etcFee || 0;
            etcTotal += courierPay + returnFee + deliveryFee + repackFee + agencyFee + removeFee + comprFee + etcPrice + etcFee;
            return etcTotal;
        } else if (pay.payType === "PT3") {
            const ttProdPrice = pay.ttProdExpense || 0;
            const ttEtcFee = pay.ttEtcFee || 0;
            const ttEtcPrice = pay.ttEtcPrice || 0;
            const ttShipExpense = pay.ttShipExpense || 0;
            integTotal += ttProdPrice + ttEtcFee + ttEtcPrice + ttShipExpense;
            return integTotal;
        }
    };

    // ★ [최적화] 1단계: 검색어 확장 필터링 (결제타입 한글, 결제수단 한글/영문 대소문자, 총금액, 최종금액 포함)
    const filteredData = useMemo(() => {
        return data.filter((cData) => {
            if (cData.childFl || cData.payStatus === "PS0") return false;

            let matchesSearch = true;
            if (searchInput.trim() !== '') {
                const keyword = searchInput.toLowerCase().trim();

                // 1. 이름 및 주문번호 검색
                const userName = (cData.orderdtDTO?.memberDTO?.userName || '').toLowerCase();
                const orderNum = (cData.orderdtDTO?.orderNumber || '').toString().toLowerCase();

                // 2. 결제타입 한글 매칭 변환 검색
                const payTypeKorean = ({
                    'PT0': '상품',
                    'PT1': '배송료',
                    'PT2': '기타',
                    'PT3': '통합'
                }[cData.payType] || '').toLowerCase();

                // 3. 결제수단 한글 및 영어(대소문자 무관) 변환 검색
                const payWayText = ({
                    'PM00': '무통장입금',
                    'PM01': 'paypal',
                    'PM02': 'wechat',
                    'PM03': 'alipay',
                    'PM04': '적립금결제',
                    'PM05': '예치금결제',
                    'PM06': 'btoragepay(global)',
                    'PM07': 'btoragepay(korean)',
                    'PM08': 'globalcard',
                    'PM09': 'koreanpay'
                }[cData.payWay] || '').toLowerCase();

                // 4. 금액 필터링용 데이터 구성 (숫자 포맷과 쉼표 포맷 모두 포함)
                const totalPrice = selectedTotalPricePrint(cData);
                const lastPrice = safeNum(cData.lastPrice);

                const totalPriceStr = totalPrice.toString();
                const totalPriceLocale = totalPrice.toLocaleString();
                const lastPriceStr = lastPrice.toString();
                const lastPriceLocale = lastPrice.toLocaleString();

                matchesSearch =
                    userName.includes(keyword) ||
                    orderNum.includes(keyword) ||
                    payTypeKorean.includes(keyword) ||
                    payWayText.includes(keyword) ||
                    totalPriceStr.includes(keyword) ||
                    totalPriceLocale.includes(keyword) ||
                    lastPriceStr.includes(keyword) ||
                    lastPriceLocale.includes(keyword);
            }

            let matchesStatus = true;
            if (selectedPaymentStatus !== '') {
                if (Array.isArray(selectedPaymentStatus)) {
                    matchesStatus = selectedPaymentStatus.includes(cData.payStatus);
                } else {
                    matchesStatus = cData.payStatus === selectedPaymentStatus;
                }
            }

            return matchesSearch && matchesStatus;
        });
    }, [data, searchInput, selectedPaymentStatus]);

    // ★ [최적화] 2단계: 정렬 처리
    const sortedData = useMemo(() => {
        let sorted = [...filteredData];

        sorted.sort((a, b) => {
            const dateA = a.payTime ? new Date(a.payTime) : new Date(a.regTime);
            const dateB = b.payTime ? new Date(b.payTime) : new Date(b.regTime);
            return dateB - dateA;
        });

        if (sortColumn) {
            sorted.sort((a, b) => {
                let aValue = a.orderdtDTO?.orderNumber;
                let bValue = b.orderdtDTO?.orderNumber;

                if (sortColumn === "userName") {
                    aValue = a.orderdtDTO?.memberDTO?.userName || "";
                    bValue = b.orderdtDTO?.memberDTO?.userName || "";
                }

                if (aValue < bValue) {
                    return sortOrder === "asc" ? -1 : 1;
                } else if (aValue > bValue) {
                    return sortOrder === "asc" ? 1 : -1;
                } else {
                    return 0;
                }
            });
        }
        return sorted;
    }, [filteredData, sortColumn, sortOrder]);

    // ★ [최적화] 3단계: 복잡한 인덱스 계산 없이 단순히 0부터 선택한 perPg 개수까지만 정교하게 잘라옴
    const visibleData = useMemo(() => {
        return sortedData.slice(0, perPg);
    }, [sortedData, perPg]);

    // ★ [최적화] 전체선택 UI 동기화 판단
    const isAllVisibleChecked = useMemo(() => {
        if (visibleData.length === 0) return false;
        return visibleData.every((item) => checked.includes(item.seqNum));
    }, [visibleData, checked]);

    // ★ [최적화] 필터링 조건이 변경될 때마다 안전하게 선택했던 체크박스 내역을 비우도록 수정
    useEffect(() => {
        setChecked([]);
    }, [searchInput, selectedPaymentStatus, startDate, endDate, perPg]);



    const [confirmPaySt, setConfirmPaySt] = useState(false);
    const confirmPayMsg1 = "입금확인을 진행하시겠습니까?";
    const confirmPayMsg2 = "진행 시 결제완료로 처리됩니다";

    const [cancelPaySt, setCancelPaySt] = useState(false);
    const cancelPayMsg1 = "입금취소를 진행하시겠습니까?";
    const cancelPayMsg2 = "진행 시 결제대기로 처리됩니다";

    const [selectedSeqNum, setSelectedSeqNum] = useState(null);

    const openConfirmPaySt = ((seqNum) => {
        setSelectedSeqNum(seqNum);
        setConfirmPaySt(true);
    })
    const closeConfirmPaySt = (() => {
        setSelectedSeqNum(null);
        setConfirmPaySt(false);
    })

    const openCancelPaySt = ((seqNum) => {
        setSelectedSeqNum(seqNum);
        setCancelPaySt(true);
    })
    const closeCancelPaySt = (() => {
        setSelectedSeqNum(null);
        setCancelPaySt(false);
    })

    const [integPayDetailPopupSt, setIntegPayDetailPopupSt] = useState(false);
    const [integPaySeqnum, setIntegPaySeqnum] = useState(null);
    const integPayDetail = ((seqnum) => {
        setIntegPaySeqnum(seqnum);
        setIntegPayDetailPopupSt(true)
    })
    const integDetailPopupClose = (() => {
        setIntegPayDetailPopupSt(false);
    })
    useEffect(() => {
        if (integPaySeqnum !== null) {
            setIntegPayDetailPopupSt(true);
        }
    }, [integPaySeqnum]);

    const convertToShipco = ((dvType, defalutShipco) => {
        if (dvType === 'D00') {
            return '국내배송';
        } else if (dvType === 'D01') {
            return 'FedEx';
        } else if (dvType === 'D16') {
            return 'FedEx-E';
        } else if (dvType === 'D11') {
            return 'UPS';
        } else if (dvType === 'D17') {
            return 'UPS-E';
        } else if (dvType === 'D02') {
            return 'EMS';
        } else if (dvType === 'D15') {
            return 'EMSP';
        } else if (dvType === 'D04') {
            return 'DHL';
        } else if (dvType === 'D13') {
            return 'K-Packet';
        } else if (dvType === 'D14') {
            return 'Small-Packet';
        } else if (dvType === 'D03') {
            return 'SEA';
        } else {
            return defalutShipco;
        }
    });

    const [payStPopup, setPayStPopup] = useState(false);

    const handleOptionClick = (status) => {
        setSelectedPaymentStatus(status);
        setPayStPopup(false);
    };

    const getDisplayText = () => {
        switch (selectedPaymentStatus) {
            case 'PS1':
                return '결제중';
            case 'PS2&PS3&PS4':
                return '결제완료';
            case 'PS5':
                return '취소';
            default:
                return '결제상태';
        }
    };

    useEffect(() => {
        if (startDate && endDate) {
            select();
        }
    }, [startDate, endDate]);

    const select = () => {
        axios({
            method: 'get',
            url: '/order/selectPayinfo',
            headers: {
                Authorization: LCAT
            },
            params: {
                startDate: stringStartDate,
                endDate: stringEndDate
            }
        })
            .then((response) => {
                const paySt = response.data.filter(cData => cData.payWay !== null && cData.payWay !== '');

                // 정렬
                paySt.sort((a, b) => new Date(b.regTime) - new Date(a.regTime));
                // paySt.sort((a, b) => {
                //     // a와 b 각각에 대해 regTime과 modiTime 중 더 최신인 시간의 데이터를 위로 정렬
                //     const timeA = new Date(a.modiTime || a.regTime || 0);
                //     const timeB = new Date(b.modiTime || b.regTime || 0);
                //     // 내림차순 정렬 (최신순)
                //     return timeB - timeA;
                // });

                if (response.data[0] && response.data[0].orderdtDTO && response.data[0].orderdtDTO.memberDTO) {
                    setUserNm(response.data[0].orderdtDTO.memberDTO.userName);
                }

                setData(paySt);
                setChecked([]);

            })
            .catch(error => {
                console.log("adminErr[00] : ", error)
            });
    };

    const payDataSucc = (seqNum) => {
        axios({
            method: 'post',
            url: '/order/adminpayconfirm',
            headers: {
                Authorization: LCAT
            },
            params: {
                seqNum: seqNum,
            }
        })
            .then(async (response) => {
                closeConfirmPaySt();
                select();
                const mbNum = response.data;
                try {
                    if(stompClient && stompClient.connected) {
                        await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: mbNum}));
                    }
                } catch (error) {
                    console.warn("결제상태 업데이트 웹소켓 전송실패:", error);
                }
            })
            .catch((error) => {
                console.log("결제완료상태 업데이트 실패 : ", error);
            });
    };

    const payDataCancel = (seqNum) => {
        axios({
            method: 'post',
            url: '/order/adminpaycancel',
            headers: {
                Authorization: LCAT
            },
            params: {
                seqNum: seqNum
            }
        })
            .then(async (response) => {
                closeCancelPaySt();
                select();
                const mbNum = response.data;
                try {
                    if(stompClient && stompClient.connected) {
                        await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: mbNum}));
                    }
                } catch (error) {
                    console.warn("결제상태 업데이트 웹소켓 전송실패 : ", error);
                }
            })
            .catch((error) => {
                console.log("결제취소상태 업데이트 실패 : ", error);
            });
    };






    return (
        <div id="m-a-payments-pg-container">
            <div className="m-a-title-frame">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">결제내역</p>
            </div>
            <div className="m-a-card display-flex flex-column">
                <div className="m-a-event-frame">
                    <div className="display-flex align-center justify-content-center" style={{marginBottom:"15px"}}>
                    <MAdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle}
                                    endHandle={endHandle}/>
                    </div>
                    <div className="m-a-header-event">
                        <div
                            className="m-a-combo font-t-cont font-c-default wd-55 ht-40 font-s-14 m-a-flex-jc-start m-r-10"
                            onClick={togglePopup}>
                            <div className="font-t-cont">{perPg}</div>
                        </div>
                        {popupVisible && (
                            <MAdminPageSmallEvent perPg={perPg} handleSelectChange={handleSelectChange}
                                                  togglePopup={togglePopup}/>
                        )}
                        <div className="m-a-combo wd-80pc ht-40 font-s-15 m-a-flex-jc-start"
                             onClick={() => setPayStPopup(true)}>
                            {getDisplayText()}
                            {payStPopup && (
                                <div className="m-a-page-popup-container" onClick={(e) => {
                                    e.stopPropagation();
                                    setPayStPopup(false);
                                }}>
                                    <div className="m-a-page-popup-frame" onClick={(e) => e.stopPropagation()}>
                                        <div className="m-a-page-popup-header-frame">
                                            <div className="font-t-title font-s-18 m-t-4">상태구분</div>
                                        </div>
                                        <div className="m-a-page-popup-body-frame">
                                            <div
                                                className={`m-a-card m-t-10 m-b-10 ${selectedPaymentStatus === "" ? "m-a-selected-option" : ""}`}
                                                onClick={() => handleOptionClick("")}>
                                                결제상태
                                            </div>
                                            <div
                                                className={`m-a-card m-t-10 m-b-10 ${selectedPaymentStatus === "PS1" ? "m-a-selected-option" : ""}`}
                                                onClick={() => handleOptionClick("PS1")}>
                                                결제중
                                            </div>
                                            <div
                                                className={`m-a-card m-t-10 m-b-10 ${selectedPaymentStatus === "PS2&PS3&PS4" ? "m-a-selected-option" : ""}`}
                                                onClick={() => handleOptionClick("PS2&PS3&PS4")}>
                                                결제완료
                                            </div>
                                            <div
                                                className={`m-a-card m-t-10 m-b-10 ${selectedPaymentStatus === "PS5" ? "m-a-selected-option" : ""}`}
                                                onClick={() => handleOptionClick("PS5")}>
                                                취소
                                            </div>
                                        </div>
                                        <div className="m-a-page-popup-footer-frame">
                                            <div className="m-a-file-bt-container">
                                                <button className="m-a-colorBt ht-40 m-b-5 wd-80" onClick={(e) => {
                                                    e.stopPropagation();
                                                    setPayStPopup(false);
                                                }}>
                                                    <div className="m-a-colorBt-text font-t-cont">Close</div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="m-a-header-event">
                        <div className="m-a-header-event-search">
                            <MAdminSearchEvent searchInput={searchInput}
                                               handleSearchInputChange={handleSearchInputChange}/>
                        </div>
                    </div>
                </div>
                <div className="m-a-tb-frame">
                    <div className="m-a-div-tb">
                        <div className="m-a-div-tb-head ht-60">
                            <div className="wd-40">
                                <input className="m-a-admin-input-chkBox m-0-a" type="checkbox"
                                       checked={isAllVisibleChecked}
                                       onChange={allcheckBoxChange}/>
                            </div>
                            <div className="wd-40"><p>번호</p></div>
                            <div className="wd-150">
                                <p>이름</p>
                                {/*{sortColumn === "orderdtDTO.memberDTO.userName" && sortOrder === "asc" && (*/}
                                {/*    <BsCaretUp className="dark-font c-point m-t-5" style={{ display: "inline-block", float: "right" }} />*/}
                                {/*)}*/}
                                {/*{sortColumn === "orderdtDTO.memberDTO.userName" && sortOrder === "desc" && (*/}
                                {/*    <BsCaretDown className="dark-font c-point m-t-5" style={{ display: "inline-block", float: "right" }} />*/}
                                {/*)}*/}
                            </div>
                            <div className="wd-200">
                                <p>주문번호</p>
                                {/*{sortColumn === "orderdtDTO.orderNumber" && sortOrder === "asc" && (*/}
                                {/*    <BsCaretUp className="dark-font c-point m-t-5" style={{ display: "inline-block", float: "right" }} />*/}
                                {/*)}*/}
                                {/*{sortColumn === "orderdtDTO.orderNumber" && sortOrder === "desc" && (*/}
                                {/*    <BsCaretDown className="dark-font c-point m-t-5" style={{ display: "inline-block", float: "right" }} />*/}
                                {/*)}*/}
                            </div>
                            <div className="wd-100"><p>결제타입</p></div>
                            <div className="wd-100"><p>결제수단</p></div>
                            <div className="wd-140"><p>총금액(&#8361;)</p></div>
                            <div className="wd-140"><p>최종금액(&#8361;)</p></div>
                            <div className="wd-80"><p>앱할인</p></div>
                            <div className="wd-80"><p>예치금사용</p></div>
                            <div className="wd-80"><p>적립금사용</p></div>
                            <div className="wd-80"><p>쿠폰사용</p></div>
                            <div className="wd-80"><p>결제상태</p></div>
                            <div className="wd-140"><p>결제일시</p></div>
                            <div className="wd-60"><p>승인</p></div>
                            <div className="wd-60"><p>취소</p></div>
                        </div>
                        {/*{sortedData.filter((cData) => !cData.childFl && cData.payStatus !== "PS0" && selectedPaymentStatus === '' || (Array.isArray(selectedPaymentStatus) ?*/}
                        {/*    selectedPaymentStatus.includes(cData.payStatus) : cData.payStatus === selectedPaymentStatus)).slice(0, displayLimit).map((cData, i) => (*/}
                        {visibleData.map((cData, i) => (
                            <div key={i} className="m-a-div-tb-body ht-70">
                                <div className="wd-40">
                                    <input className="m-a-admin-input-chkBox m-0-a" type="checkbox" name={cData.seqNum}
                                           checked={checked.includes(cData.seqNum)}
                                           onChange={() => checkBoxChange(cData.seqNum)}/>
                                </div>
                                <div className="wd-40"><p>{i + 1}</p></div>
                                <div className="wd-150"><p>{cData.orderdtDTO.memberDTO.userName}</p></div>
                                <div className="wd-200"><p>{cData.orderdtDTO.orderNumber}</p></div>
                                <div className="user-center wd-100">
                                    <p>{cData.payType === "PT0" ? "상품" : cData.payType === "PT1" ? "배송료" : cData.payType === "PT2" ? "기타" : "통합"}</p>
                                    {cData.payType === "PT3" ?
                                        <button onClick={() => integPayDetail(cData.seqNum)}
                                                className="user-center m-a-commonBt wd-40 ht-25">
                                            <p className="font-c-default">내역</p>
                                        </button>
                                        :
                                        null
                                    }
                                </div>
                                <div className="wd-100">
                                    <p>{cData.payWay === "PM00" ? "무통장입금" : cData.payWay === "PM01" ? "Paypal" : cData.payWay === "PM02" ? "Wechat" :
                                        cData.payWay === "PM03" ? "Alipay" : cData.payWay === "PM04" ? "적립금결제" : cData.payWay === "PM05" ? "예치금결제" :
                                            cData.payWay === "PM06" ? "BtoragePay(Global)" : cData.payWay === "PM07" ? "BtoragePay(Korean)" :
                                                cData.payWay === "PM08" ? "GlobalCard" : cData.payWay === "PM09" ? "KoreanPay" : null}</p>
                                </div>

                                <div className="wd-140">
                                    <p>{selectedTotalPricePrint(cData).toLocaleString()}</p>
                                </div>

                                <div className="user-center wd-140">
                                    <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                        <div>
                                        <p>{cData.lastPrice.toLocaleString() || 0}</p>
                                        {cData?.cardFee > 0 &&
                                            <p>(+{cData?.cardFee?.toLocaleString()})</p>
                                        }
                                        </div>
                                        {cData.lastForPrice > 0 ?
                                            <div className="user-center m-l-3" style={{flexDirection: "row"}}>
                                                <p className="m-0 m-l-3 font-s-11">-</p>
                                                <p className="m-0 m-l-3 font-s-13 font-c-btorage">{cData.lastForPrice}</p>
                                                <p className="m-0 m-l-3 font-s-11">{cData.forCurrency}</p>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                                <div className="wd-80"><p>{cData?.appSalePrice?.toLocaleString() || 0}</p></div>
                                <div className="wd-80"><p>{cData?.depUsePrice?.toLocaleString() || 0}</p></div>
                                <div className="wd-80"><p>{cData?.pointUsePrice?.toLocaleString() || 0}</p></div>
                                <div className="wd-80"><p>{cData?.couponUsePrice?.toLocaleString() || 0}</p></div>
                                <div className="wd-80">
                                    <p style={{color: cData.payStatus === 'PS1' ? "#276AB7" : cData.payStatus === 'PS5' ? "#EE5757" : "#FFAF34"}}>
                                        {cData.payStatus === 'PS1' ? "결제중" : cData.payStatus === 'PS5' ? "취소" : "결제완료"}
                                    </p>
                                </div>
                                <div className="wd-140">
                                    {/*<p>*/}
                                    {/*    {cData.modiTime && new Date(cData.modiTime) > new Date(cData.regTime)*/}
                                    {/*        ? cData.modiTime*/}
                                    {/*        : cData.regTime}*/}
                                    {/*</p>*/}
                                    <p>
                                        {cData.regTime}
                                    </p>
                                </div>
                                <div className="user-center wd-60">
                                    {cData.payStatus === 'PS1' && (
                                        <img className="c-point wd-30 ht-30 m-a-opc-06" alt="closeImage"
                                             src={commonCheck}
                                             onClick={() => openConfirmPaySt(cData.seqNum)}/>)}
                                </div>
                                <div className="user-center wd-60">
                                    {(cData.payStatus === 'PS1' || cData.payStatus === 'PS2') && (
                                        <img className="c-point wd-30 ht-30 m-a-opc-07" alt="closeImage"
                                             src={commonClose}
                                             onClick={() => openCancelPaySt(cData.seqNum)}/>)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/*{displayLimit >= 30 && data.length > displayLimit && (*/}
                {/*    <div className="text-center m-t-20">*/}
                {/*        <button className="m-a-commonBt wd-80 ht-30" onClick={loadMoreData}>더보기*/}
                {/*            <MdKeyboardArrowDown className="m-l3 font-s-17"/>*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*)}*/}
            </div>
            {alertShow === true ? <MsgSelectModal alertShow={alertShow} eventHandle1={modalCancel} eventHandle2={payDataSucc} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow2 === true ? <MsgSelectModal alertShow={alertShow2} eventHandle1={modalCancel2} eventHandle2={payDataCancel} msgData1={msgConfirmData3} msgData2={msgConfirmData4}/> : null}

            { confirmPaySt ?
                <MsgSelectModal confirmPaySt={confirmPaySt} confirmPayMsg1={confirmPayMsg1} confirmPayMsg2={confirmPayMsg2}
                                closeConfirmPaySt={closeConfirmPaySt} selectedSeqNum={selectedSeqNum} payDataSucc={payDataSucc}/>
                :
                cancelPaySt ?
                    <MsgSelectModal cancelPaySt={cancelPaySt} cancelPayMsg1={cancelPayMsg1} cancelPayMsg2={cancelPayMsg2}
                                    closeCancelPaySt={closeCancelPaySt} selectedSeqNum={selectedSeqNum} payDataCancel={payDataCancel}/>
                    :
                    integPayDetailPopupSt ?
                        <IntegDetailPopup integDetailPopupClose={integDetailPopupClose} integPaySeqnum={integPaySeqnum}/>
                        :
                        null
            }
        </div>
    );
}

export default MAdminPaymentsListPg
